export default {
  team_term: 'チーム',
  days_until_start:
    '%{smart_count} day until the campaign starts |||| %{smart_count} days until the campaign starts',
  now_over: 'This campaign is now over',
};
